function AccountQuickAccessFactory(container) {
  let AccountQuickAccess = class {
    constructor(container) {
      this.element = container;
      if (this.element.querySelector("[data-flickity-config]")) {
        this.carousel = new Carousel(
          this.element.querySelector("[data-flickity-config]")
        ); // Setup product item color swatch
      }
      if (this.element.querySelector('[data-customer-widget="last_order"]')) {
        this.lastOrderWidget = new CustomerOrderWidget(
          this.element.querySelector('[data-customer-widget="last_order"]')
        );
      }
    }

    onUnload() {
      this.carousel.destroy();
    }
  };
  return new AccountQuickAccess(container);
}
